import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

export default function CardRequestRedirectPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const requestTypeId = searchParams.get("requestTypeId");
    const suffix = requestTypeId ? `?requestTypeId=${requestTypeId}` : "";
    navigate(`/requests/requestTable${suffix}`, { replace: true });
  }, [navigate, searchParams]);

  return null;
}
